import i18n from '../languages/index.js'
import store from '@/store'
import * as moment from 'moment'
import * as am4core from '@amcharts/amcharts4/core'
let JSZip = require('jszip')
const colors_array = ['#00A3FF', '#7340F7', '#FF3870', '#0CFEA1', '#FFE500', '#FF2020', '#0FCC83']

let getUserInfoByToken = function (auth_token) {
  return this.$http.get(`${this.$store.getters.getBackendUrl}/users/fetch`, {
    headers: {
      'Auth-Token': auth_token
    }
  })
}

let dynamicTranslateInnerHtmlBySelector = function (selector, translate_path) {
  let elements = document.querySelectorAll(selector)
  if (elements.length > 0) {
    Array.from(elements).forEach(
      function (element) {
        element.innerHTML = i18n.t(translate_path)
      }.bind(this)
    )
  }
}

let dynamicTranslateListInnerHtmlBySelector = function (list) {
  list.forEach(function (object) {
    let elements = document.querySelectorAll(object.selector)
    if (elements.length > 0) {
      Array.from(elements).forEach(
        function (element) {
          element.innerHTML = i18n.t(object.translate_path)
        }.bind(this)
      )
    }
  })
}

let getRegExpMatches = function (string, regex, index) {
  index || (index = 1)
  var matches = []
  var match
  while ((match = regex.exec(string))) {
    matches.push(match[index])
  }
  return matches
}

let isExistValueInArrayObjects = function (array, property, value) {
  let result = false

  for (let i = 0; i < array.length; i++) {
    let object = array[i]

    if (object[property] === value) {
      result = true
      break
    }
  }
  return result
}

let getTaskResult = function (result_id, result_type, stop_time = 120000, retry_interval = 1000, url) {
  let params = {
    result_id: result_id,
    result_type: result_type
  }

  let request_url = url || `${this.$store.getters.getBackendUrl}/tasks/result`
  this.send_request_flag = true

  if (!this.stop_timer) {
    this.stop_timer = setTimeout(
      function () {
        this.send_request_flag = false
        clearTimeout(this.stop_timer)
        this.stop_timer = null
      }.bind(this),
      stop_time
    )
  }

  return this.$http
    .get(request_url, {
      params: params,
      headers: {
        'Accept-Language': this.$store.getters.getLanguage,
        'Auth-Token': this.$store.getters.getToken
      }
    })
    .then(
      function (response) {
        if (!this.send_request_flag) {
          clearTimeout(this.stop_timer)
          this.stop_timer = null
          return {
            message: i18n.t('timed_out')
          }
        }
        if (response.status === 200 && response.body.ready === false) {
          return new Promise((resolve) => {
            setTimeout(
              function () {
                resolve(getTaskResult.call(this, result_id, result_type, stop_time, retry_interval, url))
              }.bind(this),
              retry_interval
            )
          })
        } else if (response.body.ready === true) {
          clearTimeout(this.stop_timer)
          this.stop_timer = null
          return response
        } else {
          clearTimeout(this.stop_timer)
          this.stop_timer = null
          console.log('Error response', response)
        }
      }.bind(this)
    )
}

let deleteLocalStorageData = function () {
  let keys = Object.keys(localStorage)
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i]
    if (key.slice(0, 5) === 'lh-cp') {
      if (key !== 'lh-cp-app-version') {
        localStorage.removeItem(key)
      }
    }
  }
}

let addColorsToChartData = function (data, custom_colors) {
  var colors = custom_colors && custom_colors.length > 0 ? custom_colors : colors_array
  if (data.length > colors.length) {
    let diff = Math.ceil(data.length / colors.length)
    for (let di = 0; di < diff; di++) {
      colors = colors.concat(colors)
    }
  }

  for (let i = 0; i < data.length; i++) {
    data[i].color = am4core.color(colors[i])
  }
  return data
}

let deepCompareObject = function () {
  var i, l, leftChain, rightChain

  function compare2Objects(x, y) {
    var p

    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
      return true
    }

    if (x === y) {
      return true
    }

    if (
      (typeof x === 'function' && typeof y === 'function') ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number)
    ) {
      return x.toString() === y.toString()
    }

    if (!(x instanceof Object && y instanceof Object)) {
      return false
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
      return false
    }

    if (x.constructor !== y.constructor) {
      return false
    }

    if (x.prototype !== y.prototype) {
      return false
    }

    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
      return false
    }

    for (p in y) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if (typeof y[p] !== typeof x[p]) {
        return false
      }
    }

    for (p in x) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if (typeof y[p] !== typeof x[p]) {
        return false
      }

      switch (typeof x[p]) {
        case 'object':
        case 'function':
          leftChain.push(x)
          rightChain.push(y)

          if (!compare2Objects(x[p], y[p])) {
            return false
          }

          leftChain.pop()
          rightChain.pop()
          break

        default:
          if (x[p] !== y[p]) {
            return false
          }
          break
      }
    }

    return true
  }

  if (arguments.length < 1) {
    return true
  }

  for (i = 1, l = arguments.length; i < l; i++) {
    leftChain = []
    rightChain = []

    if (!compare2Objects(arguments[0], arguments[i])) {
      return false
    }
  }

  return true
}

let addEmptyRowsDataTable = function (array, per_page, table) {
  if (array.length < per_page) {
    table.context[0].oFeatures.bSort = false
    let needed_objects_number = per_page - array.length
    for (let i = 0; i < needed_objects_number; i++) {
      array.push({})
      table.rows.add([{}]).draw()
    }
    table.context[0].oFeatures.bSort = true
  }
}

let checkIsMobileOrTablet = function () {
  let match = navigator.userAgent.match(/iPhone|iPad|Android/g)
  return !!(match && match.length > 0)
}

let getOvertypeWidget = function (type) {
  if (!type) {
    return {
      text: 'widget.undefined',
      color: '#CCCCCC'
    }
  }

  switch (type) {
    case 'smart_offer':
      return {
        text: 'widget.smart_offer',
        color: '#7340F7'
      }
      
    case 'Smartoffer_Desktop':
      return {
        text: 'widget.smart_offer',
        color: '#7340F7'
      }

    case 'Smartoffer_Mobile_v2':
    return {
      text: 'widget.smart_offer',
      color: '#7340F7'
    }

    case 'generic':
      return {
        text: 'widget.generic',
        color: '#FFE500'
      }

    case 'Generic':
      return {
        text: 'widget.generic',
        color: '#FFE500'
      }  

    case 'notification':
      return {
        text: 'widget.notification',
        color: '#70FF00'
      }  

    case 'Notification':
      return {
        text: 'widget.notification',
        color: '#70FF00'
      }

    case 'Social_Proof':
      return {
        text: 'widget.notification',
        color: '#70FF00'
      }  

    case 'Average_Check_Enlarger':
      return {
        text: 'widget.notification',
        color: '#70FF00'
      }

    case 'Average_Check_Enlarger_v2':
      return {
        text: 'widget.notification',
        color: '#70FF00'
      }  

    case 'Abandoned_Cart':
      return {
        text: 'widget.notification',
        color: '#70FF00'
      }  

    case 'News_Subscription':
      return {
        text: 'widget.subscribe',
        color: '#FF3870'
      }

    case 'News_Subscription_2_steps':
      return {
        text: 'widget.subscribe',
        color: '#FF3870'
      }
      
    case 'News_Subscription_3_steps':
      return {
        text: 'widget.subscribe',
        color: '#FF3870'
      }  

    case 'Subscribe':
      return {
        text: 'widget.subscribe',
        color: '#FF3870'
      }
      
    case 'subscribe':
    return {
      text: 'widget.subscribe',
      color: '#FF3870'
    }  

    case 'wish_list':
      return {
        text: 'widget.wish_list',
        color: '#00A3FF'
      }

      case 'wish_list_noframe':
      return {
        text: 'widget.wish_list',
        color: '#00A3FF'
      }

    case 'Рекомендации':
      return {
        text: 'widget.recommendations',
        color: '#1E1EF5'
      }
    case 'recommendations':
      return {
        text: 'widget.recommendations',
        color: '#1E1EF5'
      }

    case 'Coupon': 
      return {
        text: 'widget.coupon',
        color: '#1E1EF5'
      }

    case 'Wheel_Of_Fortune': 
      return {
        text: 'widget.smart_offer',
        color: '#7340F7'
      } 
      
    case 'Wheel_Of_Fortune_mobile': 
      return {
        text: 'widget.smart_offer',
        color: '#7340F7'
      }

    case 'Last_Viewed':
      return {
        text: 'widget.last_viewed',
        color: '#00A3FF'
      }
    case 'Scratch':  
      return {
        text: 'widget.smart_offer',
        color: '#7340F7'
      }

    default:
      return {
        text: 'widget.undefined',
        color: '#CCCCCC'
      }
  }
}

let checkWindowOrientation = function () {
  if (screen.orientation && screen.orientation.type) {
    return screen.orientation && screen.orientation.type === 'portrait-primary' ? true : false
  } else if (navigator.userAgent.match(/Safari/)) {
    var mql = window.matchMedia('(orientation: portrait)')
    return mql.matches
  } else {
    return false
  }
}

let logout = function () {
  deleteLocalStorageData()
  let need_update_version = store.state.notifications.some(function (notification) {
    if (notification && notification.name && notification.name === 'need_soft_redirect') {
      return true
    } else {
      return false
    }
  })
  if (need_update_version) {
    localStorage.setItem('lh-cp-app-version', process.env.APP_VERSION)
    store.commit('removeNotificationByName', 'need_soft_redirect')
  }
  window.location.reload(true)
}

let checkSiteStatus = function () {
  if (
    this.$store.state.user &&
    !this.$store.state.user.sites.length &&
    this.$route.name !== 'authorization'
  ) {
    if (this.$route.name !== 'settings_sites_list') {
      this.$router.push({ name: 'settings_sites_list' })
    }
  } else if (!this.$store.getters.getSiteStatus) {
    this.$http
      .get(
        `${this.$store.getters.getBackendUrl}/users/site/${this.$store.getters.getSiteId}/status`,
        {
          headers: {
            'Accept-Language': this.$store.getters.getLanguage,
            'Auth-Token': this.$store.getters.getToken
          }
        }
      )
      .then(
        function (response) {
          this.$store.commit('setSiteStatus', response.body)
          // let status_site = JSON.parse(JSON.stringify(this.$store.getters.getSiteStatus))
          // if (!status_site.feed) {
          //   if (!(this.$route.name === 'settings_sites_list' || this.$route.name === 'settings')) {
          //     this.$router.push({ name: 'technical_account_settings' })
          //   }
          // }
        }.bind(this)
      )
      .catch(
        function (reject) {
          console.log('Error checkSiteStatus', reject)
        }.bind(this)
      )
  }
}

let setCurrentSiteAndTariffToVuex = function () {
  if (!this.$store.getters.getSiteId) return

  let priomise_site = getSiteInfoById.call(this, this.$store.getters.getSiteId)
  let priomise_tariffs = getTariffs.call(this)

  Promise.all([priomise_site, priomise_tariffs]).then(
    function (responses) {
      this.$store.commit('setCurrentSiteInfo', responses[0].body.sites[0])
      let tariff_id = responses[0].body.sites[0].tariff
      let tariffs = responses[1].body.tariffs
      let index = tariffs.findIndex(function (tariff) {
        if (tariff.id === tariff_id) return true
        else return false
      })

      if (index !== -1) {
        this.$store.commit('setCurrentSiteTariff', tariffs[index])
      }
    }.bind(this)
  )
}

let getSiteInfoById = function (site_id) {
  return this.$http.get(
    `${this.$store.getters.getBackendUrl}/users/sites_info?site_ids=${site_id}`,
    {
      headers: {
        'Accept-Language': this.$store.getters.getLanguage,
        'Auth-Token': this.$store.getters.getToken
      }
    }
  )
}

let getTariffs = function () {
  return this.$http.get(`${this.$store.getters.getBackendUrl}/users/site/tariffs/list`, {
    headers: {
      'Accept-Language': this.$store.getters.getLanguage,
      'Auth-Token': this.$store.getters.getToken,
      'Leadhit-Site-Id': this.$store.getters.getSiteId
    }
  })
}

let validateEmail = function (email) {
  return email.length > 0 &&
    email.match(store.getters.regExp.email) &&
    email.match(store.getters.regExp.email).length > 0
    ? true
    : false
}

let archiveAndDownloadFiles = async function (files, archive_name = 'leadhit_compress.zip') {
  try {
    let zip = new JSZip()

    for (let i = 0; i < files.length; i++) {
      let file = files[i]
      zip.file(file.name, file.content)
    }

    await zip.generateAsync({ type: 'blob' }).then(function (blob_data) {
      let zip_blob = new Blob([blob_data])

      let element = window.document.createElement('a')
      element.href = window.URL.createObjectURL(zip_blob)
      element.download = archive_name
      element.click()
    })

    return 'success'
  } catch (error) {
    console.log('Error in archiveAndDownloadFiles: ', error)
    return 'error'
  }
}

let getContentFromFiles = async function (files) {
  try {
    let data = []
    for (let i = 0; i < files.length; i++) {
      let file_reader = new FileReader()
      file_reader.readAsText(files[i], 'UTF-8')

      let result = await new Promise(function (resolve) {
        file_reader.onload = function () {
          resolve(file_reader.result)
        }
      })

      data.push({
        name: files[i].name,
        content: result
      })
    }

    return data
  } catch (error) {
    console.log('Error in getContentFromFiles: ', error)
    return 'error'
  }
}

const getImageUrl = function (image_name) {
  return require('@/assets/' + image_name)
}

const formatDatesForRequest = (date) => {
  if (!date) return null

  if (typeof date === 'object') {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('.')[0]
  }

  if (typeof date === 'number') {
    return new Date(date - new Date(date).getTimezoneOffset() * 60000).toISOString().split('.')[0]
  }
}

const adaptMessageCard = function (message) {
  if (!message) {
    return { email_stats: [{}] }
  }

  const stats = message.stats || {}
  const deliver = message.deliver
  const adapted = Object.assign({}, message, {
    email_stats: [stats],
    deliver_date: deliver ? moment(deliver).format('DD.MM.YYYY') : '',
    deliver_time: deliver ? moment(deliver).format('HH:mm') : 'No delay'
  })

  if (message.case_messages && message.case_messages.length) {
    adapted.case_message = message.case_messages
  }

  if (message.autocast && !Array.isArray(message.autocast)) {
    adapted.autocast = [message.autocast]
  }

  return adapted
}

const adaptRecipientRows = function (rows) {
  return (rows || []).map(function (row) {
    return Object.assign({}, row, {
      recipient: row.recipient || row.lead_id,
      error_message: row.error
    })
  })
}

export {
  getUserInfoByToken,
  dynamicTranslateInnerHtmlBySelector,
  dynamicTranslateListInnerHtmlBySelector,
  getRegExpMatches,
  isExistValueInArrayObjects,
  getTaskResult,
  deleteLocalStorageData,
  addColorsToChartData,
  deepCompareObject,
  checkIsMobileOrTablet,
  addEmptyRowsDataTable,
  getOvertypeWidget,
  checkWindowOrientation,
  logout,
  checkSiteStatus,
  setCurrentSiteAndTariffToVuex,
  getTariffs,
  validateEmail,
  archiveAndDownloadFiles,
  getContentFromFiles,
  getImageUrl,
  formatDatesForRequest,
  adaptMessageCard,
  adaptRecipientRows
}



// WEBPACK FOOTER //
// ./src/utils/index.js